import React from 'react';
import { addLinkTestId } from '../../helpers/addTestId';
import uniqueId from '../../helpers/uniqueId';
import {
  runNavigationEventData,
  getLanguageLink,
} from '../../helpers/navigationHelpers';
import { Link as ContentfulLink } from './types/Navigation.types';
import { TopBarNavigationItem, TopBarWrapper } from './styles/TopBar.styles';
import { Link, withPrefix } from 'gatsby';
import { useLocation } from '@gatsbyjs/reach-router';

type TopBarProps = {
  topLevelLinks: ContentfulLink[];
  languageLink: ContentfulLink;
  pageTitle: string;
  isSecondLanguageOnUrl: boolean | undefined;
  secondLanguageUrlPrefix: string | undefined;
};

const TopBar: React.FC<TopBarProps> = ({
  topLevelLinks,
  languageLink,
  pageTitle,
  isSecondLanguageOnUrl,
  secondLanguageUrlPrefix,
}) => {
  const { pathname } = useLocation();

  return (
    <TopBarWrapper className="top-bar">
      <div className="top-bar-grid">
        <div className="top-bar-column-2">
          <ul>
            {topLevelLinks.map(topLevelLink => (
              <li key={topLevelLink.id}>
                <TopBarNavigationItem
                  href={topLevelLink.url}
                  isSelected={topLevelLink.isSelected}
                  id={topLevelLink.contentful_id}
                  title={topLevelLink.name}
                  data-analytics-element={uniqueId(topLevelLink.name)}
                  data-analytics-context={pageTitle}
                  data-analytics-category="Link"
                  data-testid={addLinkTestId('topLevelLink', topLevelLink.name)}
                  onClick={async () => {
                    await runNavigationEventData({ location: 'header' });
                  }}
                >
                  {topLevelLink.name}
                </TopBarNavigationItem>
              </li>
            ))}
          </ul>
          <ul>
            {languageLink && languageLink.name !== 'no_name' && (
              <li>
                <Link
                  to={getLanguageLink(
                    pathname,
                    secondLanguageUrlPrefix,
                    isSecondLanguageOnUrl
                  )}
                  id={languageLink.contentful_id}
                  title={languageLink.name}
                  data-analytics-element={uniqueId(languageLink.name)}
                  data-analytics-context={pageTitle}
                  data-analytics-category="Link"
                  data-testid={addLinkTestId('topLevelLink', languageLink.name)}
                >
                  {languageLink.name}
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </TopBarWrapper>
  );
};

export default TopBar;
